import { formatNumbersInString, thousandSeparator } from "./dataFormatter";
let moment = require('moment');

const fieldNamesWithoutFormatting = ["year", "EventYear", "InfoObjectID"]
const numberLikeRegexp = /\d+\.\d{3,}/;

export function formatObject(input: any): any {
    if (input === null || typeof input !== 'object') return input;

    if (Array.isArray(input)) {
        return formatArray(input);
    }

    const result: Record<string, any> = {};

    for (const [key, value] of Object.entries(input)) {
        result[key] = formatValue(key, value);
    }

    return result;
}

function formatValue(key: string, value: any): any {
    if (fieldNamesWithoutFormatting.includes(key) || value === null || typeof value === 'boolean') {
        return value;
    }

    if (typeof value === 'string') {
        return formatString(value);
    }

    if (typeof value === 'number') {
        return formatNumber(value);
    }

    if (Array.isArray(value)) {
        return formatArray(value);
    }

    if (typeof value === 'object') {
        return formatObject(value);
    }

    return value;
}

function formatString(str: string): string | null {
    if (str.trim() === '') return null;

    if (moment(str, moment.ISO_8601, true).isValid()) {
        return moment(str).format('DD.MM.YYYY HH:mm');
    }

    if (moment(str, 'YYYY-MM-DD', true).isValid()) {
        return moment(str).format('DD.MM.YYYY');
    }

    if (numberLikeRegexp.test(str)) {
        return formatNumbersInString(str);
    }

    return str;
}

function formatNumber(num: number): string {
    return Number.isInteger(num)
        ? thousandSeparator(num.toString())
        : thousandSeparator(num.toFixed(3));
}

function formatArray(arr: any[]): any[] {
    return arr.map(item => {
        if (typeof item === 'number') {
            return Number(item.toFixed(6));
        }

        if (Array.isArray(item)) {
            return item.map(subItem =>
                typeof subItem === 'number' ? Number(subItem.toFixed(6)) : formatObject(subItem)
            );
        }

        if (typeof item === 'object') {
            return formatObject(item);
        }

        return item;
    });
}
